// extracted by mini-css-extract-plugin
export default {"list":"List-module__list___OcUnc"};